import axios from "axios";
import { getDevBearerOverride } from "@/lib/dev-bearer";
import { GINJA_APP_SERVICE_API_BASE, SSO_COOKIE_SENTINEL } from "@/services/ginjaAuth";

/**
 * Product API axios client — `withCredentials` + Bearer only for a real JWT in `token`, else legacy `hr-auth-token`.
 */
export const authApi = axios.create({
  baseURL: GINJA_APP_SERVICE_API_BASE,
  withCredentials: true,
});

authApi.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};
  const h = config.headers as Record<string, string>;
  const dev = getDevBearerOverride();
  if (dev) {
    h.Authorization = `Bearer ${dev}`;
    return config;
  }
  const t = localStorage.getItem("token");
  if (t && t !== SSO_COOKIE_SENTINEL) {
    h.Authorization = `Bearer ${t}`;
  } else {
    delete h.Authorization;
  }
  const hr = localStorage.getItem("hr-auth-token");
  if (!h.Authorization && hr) {
    h.Authorization = `Bearer ${hr}`;
  }
  return config;
});

export async function authApiLogout(): Promise<void> {
  try {
    await authApi.post("/user/logout", {});
  } catch {
    /* ignore */
  }
}
